var map = {
	"./accessibility.svg": 4049,
	"./angular.svg": 5439,
	"./azure.svg": 1084,
	"./berg.png": 8341,
	"./css.svg": 9900,
	"./cta-illustration.svg": 4354,
	"./django.svg": 6238,
	"./dotnet-framework.svg": 1758,
	"./dotnet.svg": 4269,
	"./drupal.svg": 5637,
	"./features-split-image-01.png": 1305,
	"./houseoftracks.png": 3804,
	"./html.svg": 4956,
	"./illustration-section-01.svg": 7005,
	"./illustration-section-02.svg": 9182,
	"./java.svg": 7515,
	"./javascript.svg": 1130,
	"./logo.svg": 3914,
	"./minor.png": 5112,
	"./profile2.png": 6508,
	"./python.svg": 33,
	"./react.svg": 9624,
	"./redux.svg": 7031,
	"./tensorflow.svg": 5104,
	"./thesis.png": 5019,
	"./triodos.png": 6559,
	"./vattenfall.png": 8426,
	"./vlk.png": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;